// Stores universal configs
// 线上环境
const config = {
  production: true,
  urlScheme: process.env.URL_SCHEME || "https", // 前端url scheme
  host: process.env.HOST || "api.ent-v3-dev.kuban.io", // API域名
  socket_url: process.env.SOCKET_URL || "https://socket.ent-v3-dev.kuban.io",
  apiToken:
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6OTM3OCwidmVyc2lvbiI6MSwiZXhwIjoxNjc5NjQxNzM2LCJpYXQiOjE2NDgwODQ3ODQsImVudGVycHJpc2VfaWQiOm51bGx9.PXYnmvPBIYFymGcSGd8JBLMS-9WjOFro6Nf-kAzLLKA",
  fengmap: {
    key: "784ce34083545d12ea066be442670b8d", // branding的code name
    appname: "kubantest1" // branding在页面显示的名字
  },
  locationId: 284 // 大屏对应的location
};

export default config;
// jwt_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6OTM3OCwidmVyc2lvbiI6MSwiZXhwIjoxNjc5NTgxNzg3LCJpYXQiOjE2NDgwMjQ4MzUsImVudGVycHJpc2VfaWQiOm51bGx9.osfxiAiTcVUUht7V0bP1XoaKM6J7MdLReR1E3tYxVYU"
// jwt_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6OTM3OCwidmVyc2lvbiI6MSwiZXhwIjoxNjc5NjQxNzM2LCJpYXQiOjE2NDgwODQ3ODQsImVudGVycHJpc2VfaWQiOm51bGx9.PXYnmvPBIYFymGcSGd8JBLMS-9WjOFro6Nf-kAzLLKA"
